import {
  faBriefcase,
  faBuilding,
  faClock,
  faGlobe
} from '@fortawesome/pro-solid-svg-icons'
import { formatDistanceToNow } from 'date-fns'
import { fr } from 'date-fns/locale'
import { Card } from '~/components/Global/Blocks/Card'
import { MetaItem } from '~/components/Global/Blocks/Card/MetaItem'
import { LabelWithIcon } from '~/components/Global/Elements/LabelWithIcon/LabelWithIcon'
import { NameCircle } from '~/components/Global/Elements/NameCircle/NameCircle'
import type { CompanyHead } from '~/domains/companies/types'
import { useOrderHead } from '~/domains/orders/queries/useOrderHead'
import type { OrderHead } from '~/domains/orders/types'
import { formatName } from '~/utils/names'
import type { ApplicationInfosResponse } from '../types'

type ApplicationCardProps = {
  application: ApplicationInfosResponse
  onClick?: () => void
}

export const ApplicationCard = ({
  application,
  onClick
}: ApplicationCardProps) => {
  const fullName = formatName(application.applicant ?? application)
  const { data: orderHeadData } = useOrderHead<
    OrderHead & { company: CompanyHead }
  >({
    orderId: application.order?.id,
    additionalFields: ['company']
  })

  const timeAgo = formatDistanceToNow(new Date(application.receivedAt), {
    addSuffix: true,
    locale: fr
  })

  const offerTitle = application.offer?.title || application.offer?.titleFull

  const metaData = [
    <MetaItem key="receivedAt">
      <LabelWithIcon icon={faClock}>{timeAgo}</LabelWithIcon>
    </MetaItem>,
    <MetaItem key="jobboardName">
      <LabelWithIcon icon={faGlobe}>{application.jobboardName}</LabelWithIcon>
    </MetaItem>
  ]

  return (
    <Card
      onClick={onClick ? () => onClick() : undefined}
      icon={<NameCircle name={fullName} size={40} inversedTheme />}
      title={fullName}
      metaData={metaData}
    >
      {orderHeadData?.company.name && (
        <LabelWithIcon icon={faBuilding}>
          {orderHeadData?.company.name}
        </LabelWithIcon>
      )}
      {offerTitle && (
        <LabelWithIcon icon={faBriefcase}>
          {/* biome-ignore lint/security/noDangerouslySetInnerHtml: @todo no explaination */}
          <span dangerouslySetInnerHTML={{ __html: String(offerTitle) }} />
        </LabelWithIcon>
      )}
    </Card>
  )
}
